module.exports = "/_next/static/images/SelfServeAnalytics-95a3c0dffe2c1e21422e7ee722c2296c.png";